module.exports = __webpack_public_path__ + "static/bg29-2925c550d994aa3a8cd1e8a9d41ac128.jpg";